$(function ($) {
  /*---------------- Mobile Menu ------------------*/

  $(".m-menu-btn").click(function() {
    $("#header").toggleClass("menu-open");
    $(this).toggleClass("m-menu-btn-ext");
  });

  /*---------------- Search Popup ------------------*/
  $(".search-toggle").on('click', function(e) {
    $("#header").toggleClass('search-active');
    e.preventDefault();
  });

  /*---------------- Shop Page Sidebar ------------------*/
  $( ".title" ).click(function() {
    if($(this).parent().hasClass('active')){
      $( this ).parent().removeClass( "active" );
    }else{
      $(this).parent().siblings().removeClass( "active" );
      $( this ).parent().addClass( "active" );
    }
  });

  /*---------------- Products Slider Slider ------------------*/
  $('.products-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3
        }
      },

      {
        breakpoint: 940,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  /*start: product details thumb slider*/
  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
        }
      },
      {
        breakpoint: 381,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false,
        }
      }
    ]
  });

  $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  $('.shop-slider-nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(".shop-slider-nav .slick-slide").each(function () {
      $(this).find('.thumb-container').removeClass('custom-border');
    });
    $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  });
  /*end: product details thumb slider*/

  /*---------------- Easy Responsive Tab ------------------*/
  $('#parentHorizontalTab').easyResponsiveTabs({
    type: 'default', //Types: default, vertical, accordion
    width: 'auto', //auto or any width like 600px
    fit: true, // 100% fit in a container
    tabidentify: 'hor_1', // The tab groups identifier
    activate: function(event) { // Callback function if tab is switched
      var $tab = $(this);
      var $info = $('#nested-tabInfo');
      var $name = $('span', $info);
      $name.text($tab.text());
      $info.show();
    }
  });
  /*---------------- Easy Responsive Tab ------------------*/

  /*---------------- Wholesale Easy Responsive Tab ------------------*/
  if ($('#wholesaleVerticalTab').length) {
    $('#wholesaleVerticalTab').easyResponsiveTabs({
      type: 'vertical', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });
  }
  /*---------------- vEasy Responsive Tab ------------------*/

  /*---------------- Magnific Youtube ------------------*/

  $('.magnific-youtube').magnificPopup({
    disableOn: 200,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });


  /*Start: Mobile sidebar filters*/
  if ($(window).width() < 768) {
    filter_popup();
  }
  $(window).on('resize', function(){
    if ($(window).width() < 768) {
      filter_popup();
    }
    else {
      $('.sidebar-sec').removeClass('mfp-hide');
    }
  });

  function filter_popup() {
    $('.mob-filter').magnificPopup({
      delegate: 'a',
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    $('.sidebar-sec').addClass('mfp-hide');
  }
  /*End: Mobile sidebar filters*/

  /*start: plus-minus quantity box*/
  $('.qty-btn.plus').click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  // This button will decrement the value till 0
  $(".qty-btn.minus").click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  /*end: plus-minus quantity box*/

  /**/
  if ($('.simulation-container .simu-bg-img ul li').length) {
    $('.simulation-container .simu-bg-img ul:first-child li:first-child').addClass('active');
    $('.simulation-container .simu-bg-img').on('click', 'ul li a', function(e) {
      $(".simulation-container .simu-bg-img ul li").each(function () {
        $(this).removeClass('active');
      });
      $(this).closest('li').addClass('active');
      e.preventDefault();
      var current_audio = $(this).attr("href");
      $('#hearing-main-audio source').attr("src",current_audio);
      $("#hearing-main-audio").load();
      //console.log($("#hearing-main-audio"));
      $("#hearing-main-audio").attr("autoplay",true);
      //$("#hearing-main-audio").autoplay;
    });
  }
  /**/

  /*---------------- Equal Height Div ------------------*/
  var maxHeight = 0;
  $(".products-wrp .product-text").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $(".products-wrp .product-text").height(maxHeight);
  /*---------------- Equal Height Div ------------------*/

  /*---------------- Only numbers ------------------*/
  jQuery.fn.ForceNumericOnly = function() {
    return this.each(function()
                     {
      $(this).keydown(function(e)
                      {
        var key = e.charCode || e.keyCode || 0;
        // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
        // home, end, period, and numpad decimal\
        return (
          key == 8 || 
          key == 9 ||
          key == 13 ||
          key == 46 ||
          key == 110 ||
          key == 190 ||
          (key >= 35 && key <= 40) ||
          (key >= 48 && key <= 57) ||
          (key >= 96 && key <= 105));
      });
    });
  };
  $(".audiogram-response input").ForceNumericOnly();
  //$(".extra-properties input").ForceNumericOnly();
  /*---------------- Only numbers ------------------*/

  /*---------------- Max 130 value ------------------*/
  $('.audiogram-response').on('keyup', 'input', function(e) {
    var val = parseInt($(this).val()),
        max = 130;

    val = isNaN(val) ? '' : Math.max(Math.min(val, max), 0);
    $(this).val(val);
  });

  $('.extra-properties').on('keyup', 'input', function(e) {
    var val = parseInt($(this).val()),
        max = 130;
    var key = e.which;
    //console.log(key);
    if ($(this).val() > 0 || $(this).val() != '') {
      if (key == 13) {
        val = isNaN(val) ? 0 : Math.max(Math.min(val, max), 0);
        $(this).val(val);
      }
    }
  });

  $('.extra-properties').on('blur', 'input', function(e) {
    var val = parseInt($(this).val()),
        max = 130;

    val = isNaN(val) ? 0 : Math.max(Math.min(val, max), 0);
    $(this).val(val);
  });
  /*---------------- Max 130 value ------------------*/

  $('.audiogram-response').on('keyup', 'input', function (e) {
    //console.log(e);
    var key = e.which;
    if ($(this).val() > 0 || $(this).val() != '') {
      if (key == 78) {
        if ($(this).parent().find('.input-header').is(":visible")) {
          $(this).parent().find('.input-header').css({'display': 'none'});
          $(this).parent().find('.input-header input.hidden-control').val("");
        }
        else {
          $(this).parent().find('.input-header').css({'display': 'block'});
          $(this).parent().find('.input-header input.hidden-control').val("N.R.");
        }
      }
    }
  });

  /*---------------- Ear products page ------------------*/
  $('.audiogram-response').on('click','.copy-to-left',function(e){
    e.preventDefault();
    var get_table_data = $(this).parent().find('table.audiogram-response-right tbody td');
    $(get_table_data).each(function (index,value) {
      var copy_val = $(this).find('input').val();
      $('table.audiogram-response-left tbody td:eq('+index+')').find('input').val(copy_val);
    });
  });

  $('.audiogram-response').on('click','.copy-to-right',function(e){
    e.preventDefault();
    var get_table_data = $(this).parent().find('table.audiogram-response-left tbody td');
    $(get_table_data).each(function (index,value) {
      var copy_val = $(this).find('input').val();
      $('table.audiogram-response-right tbody td:eq('+index+')').find('input').val(copy_val);
    });
  });
  /*---------------- Ear products page ------------------*/

  /*---------------- Multi level menu ------------------*/
  if ($(window).width() < 1024) {
    $('.top-level-menu li .submenu-dropdown').on("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      $(this).toggleClass('glyphicon-plus glyphicon-minus');
      $(this).parent().next('.menu-dropdown').slideToggle(600);
    });
  }
  /*---------------- Multi level menu ------------------*/

  if ($("#shopify-product-reviews").length) {
    $("body").on('click', '#redirect_reviews_tab', function(e) {
      e.preventDefault();
      var mytab = $("#shopify-product-reviews").parents('.tabcontent.tab-content').attr('id');
      $("#shopify-product-reviews").parents("#parentHorizontalTab").find("li[data-content-id='#"+mytab+"']").click();
      $('html, body').animate({
        scrollTop: $("#shopify-product-reviews").offset().top
      }, 2000);
    });
  }
});